module.exports = __webpack_public_path__ + "static/img/materialsax04.ac84c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax04.png
// module id = rArw
// module chunks = 2